import { EBatchStatus, EBatchType } from '../enums/batch.enum';
import { OptionDescription } from '../types/option.type';
import { StatusRecord } from '../types/status.type';

export const BATCH_STATUS: StatusRecord<EBatchStatus> = {
  [EBatchStatus.draft]: {
    id: EBatchStatus.draft,
    name: 'Draft',
    filterName: 'Draft',
    class: 'status-box-default',
  },
  [EBatchStatus.schedulingPending]: {
    id: EBatchStatus.schedulingPending,
    name: 'Scheduling Pending',
    filterName: 'Scheduling Pending',
    class: 'status-box-purple',
  },
  [EBatchStatus.pending]: {
    id: EBatchStatus.pending,
    name: 'Pending',
    filterName: 'Pending',
    class: 'status-box-warning',
  },
  [EBatchStatus.schedulingApprove]: {
    id: EBatchStatus.schedulingApprove,
    name: 'Scheduling Approve',
    filterName: 'Scheduling Approve',
    class: 'status-box-purple',
  },
  [EBatchStatus.approved]: {
    id: EBatchStatus.approved,
    name: 'Approved',
    filterName: 'Approved',
    class: 'status-box-success',
  },
};


export const BATCH_TYPE: Record<EBatchType, OptionDescription<EBatchType>> = {
  [EBatchType.transaction]: {
    id: EBatchType.transaction,
    value: EBatchType.transaction,
    viewValue: 'Transaction',
  },
  [EBatchType.blankForm]: {
    id: EBatchType.blankForm,
    value: EBatchType.blankForm,
    viewValue: 'Blank Form',
  },
};